import { useEffect, useMemo, useState } from 'react';
import { Container, Button, Text, DeprecatedIcon } from '@vinted/web-ui';
import { getPrivacyPolicy } from 'data/api';
import useFetch from 'hooks/useFetch';
import useTranslate from 'hooks/useTranslate';
import BackToTopButton from 'components/BackToTopButton';
import ContentLoader from 'components/ContentLoader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const PrivacyPolicy = () => {
  const {
    0: isExpanded,
    1: setIsExpanded
  } = useState(false);
  const translate = useTranslate();
  const {
    fetch: fetchPrivacyPolicy,
    data,
    isLoading
  } = useFetch(getPrivacyPolicy);
  useEffect(() => {
    fetchPrivacyPolicy();
  }, [fetchPrivacyPolicy]);
  const privacyPolicyContent = useMemo(() => {
    if (!(data !== null && data !== void 0 && data.body)) {
      return undefined;
    }

    const updateDetailsElement = detailsElement => {
      if (!isExpanded) {
        detailsElement.removeAttribute('open');
        return;
      }

      detailsElement.setAttribute('open', 'true');
    };

    const parser = new DOMParser();
    const serializer = new XMLSerializer();
    const document = parser.parseFromString(data.body, 'text/html');
    const allDetailsElements = document.querySelectorAll('details');
    allDetailsElements.forEach(updateDetailsElement);
    return serializer.serializeToString(document);
  }, [data, isExpanded]);

  const handleButtonClick = () => {
    setIsExpanded(currentState => !currentState);
  };

  const renderExpandAllButton = () => {
    if (!privacyPolicyContent) return null;
    const buttonText = isExpanded ? translate('privacy_policy_details_button.collapse_all') : translate('privacy_policy_details_button.expand_all');
    return /*#__PURE__*/_jsx("div", {
      className: "u-ui-padding-top-x2-large u-ui-padding-left-medium",
      children: /*#__PURE__*/_jsx(Button, {
        text: buttonText,
        styling: Button.Styling.Flat,
        size: Button.Size.Small,
        onClick: handleButtonClick,
        deprecatedIcon: /*#__PURE__*/_jsx(DeprecatedIcon, {
          name: isExpanded ? 'x' : 'plus',
          color: DeprecatedIcon.Color.Primary,
          size: DeprecatedIcon.Size.XSmall
        }),
        inline: true
      })
    });
  };

  if (isLoading) {
    return /*#__PURE__*/_jsx(ContentLoader, {
      testId: "privacy-policy-loader"
    });
  }

  return /*#__PURE__*/_jsxs("article", {
    className: "privacy-policy-content user-created-content",
    children: [renderExpandAllButton(), /*#__PURE__*/_jsx(Container, {
      styling: Container.Styling.Wide,
      children: /*#__PURE__*/_jsx(Text, {
        text: privacyPolicyContent,
        html: true
      })
    }), /*#__PURE__*/_jsx(BackToTopButton, {})]
  });
};

export default PrivacyPolicy;